function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { useContext } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import Grid from "../Grid/Grid";
import GridCell from "../Grid/GridCell";
import Icon from "../Icon/Icon";
import Link from "../Typography/Link";
import DialogContext from "./DialogContext";
export default function DialogHeader(props) {
  const {
    children,
    className,
    ...rest
  } = props;
  const {
    onRequestClose
  } = useContext(DialogContext);
  const classes = classnames("ax-dialog__header", className);
  return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
    className: classes
  }), /*#__PURE__*/React.createElement(Grid, {
    responsive: false,
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(GridCell, null, children), /*#__PURE__*/React.createElement(GridCell, {
    shrink: true
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: onRequestClose,
    style: "subtle"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross",
    size: "1.5rem"
  })))));
}